import { replaceInUrl, postRequest } from './index';
import apiEndpoints from './apiEndpoints';

export const setFingerprintRequest = (data) =>
  postRequest(
    replaceInUrl(apiEndpoints.affiliate.setFingerprint, {
      data,
    }),
    data,
  );

export const saveTrackingDetailsRequest = (data) =>
  postRequest(apiEndpoints.affiliate.saveTrackingDetails, data);
